import { graphql } from '@graphql/__generated'

export const GET_EVENT_CODES_BY_ID = graphql(`
  query getEventCodesById($input: GetEventByIdInput!) {
    getEventById(input: $input) {
      eventId
      attendees {
        email
        name
        orderId
        ticketCode
        badgePrintedAt
      }
      discounts {
        quantity
        title
        tickets
        type
        code
        percentage
        amount
      }
    }
  }
`)
